module.exports = __webpack_public_path__ + "static/media/sort_selection_general.da0329ed.svg";